export default __webpack_public_path__ + "static/media/rightArrowGray.27bda134.svg";